<template>
	<div>
		<vxe-modal v-model="modal_model" :title="modal_title" :width="modal_width" :height="modal_height" @show="modal_onshow" show-footer @hide="modal_onhide"
			destroy-on-close>
			<template #default>
				<vxe-grid v-if="list_gridOptions" v-bind="list_gridOptions" @toolbar-button-click="list_toolbarButtonClickEvent" ref="directlystockinList"></vxe-grid>
			</template>
			<template #footer>
				<vxe-button status="" content="返回" @click="modal_cancel"></vxe-button>
			</template>
		</vxe-modal>
	</div>
</template>
<style scoped>

</style>
<script>
	import listMixins from '@_system/components/base/mixins/list/list.js'
	import modalMixins from '@_system/components/base/mixins/modal/modal.js'
	export default {
		mixins: [listMixins,modalMixins],
		props: {
			row: {
				default: () => {
					return []
				}
			},
		},
		data() {
			return {
				modal_model:false,
				modal_title: '直接入库单',
				modal_width:1000,
				modal_height:800,
				list_formConfig: [{
					field: 'stockCode',
					title: '单据编码',
					itemRender: {
						name: '$input'
					}
				}, 
				// {
				// 	title: '操作',
				// 	fixed: "right",
				// 	align: 'center',
				// 	width: 65,
				// 	slots: {
				// 		default: ({row}) => {
				// 			return [<el-button type = "text" size = "mini" onClick = {() => {this.ddcode(row)}}>凭证</el-button>]
				// 		}
				// 	}
				// }
				],
				// list_footerField:[
				// 	{field:'needamount',toFixed:2}
				// ]
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {
			
		},
		methods: {
			list_beforeCreateGrid(gridOptions){
				gridOptions.toolbarConfig.buttons = [{
						name: '同步金蝶',
						status: 'success',
						code: 'sendjindie'
				}]
				gridOptions.columns = [{
						type:'checkbox',
						title: '#',
						width:50
					},{
						field: 'stockCode',
						title: '单据编码',
					},
					{
						field: 'export_jindie',
						title: '金蝶',
						slots : {
							default:({row})=>{
								if(row.export_jindie){
									if(row.export_jindie_sucess == 1){
										return <span style="color:#67C23A;">已同步</span>
									}else{
										if(row.export_jindie_error){
											let error = row.export_jindie_error.map((item)=>{
												return item.Message
											})
											//console.log(row.export_jindie_error)
											return <span style="color:#F56C6C;">{error.join(',')}</span> 
										}else{
											return <span style="color:#F56C6C;">同步失败</span> 
							
										}									
									}
								}else{
									return '未同步'
								}
							}
						}
					}
				]
				gridOptions.pagerConfig.enabled = true
			},
			list(page,updateForm,other) {
				return new Promise((resolve,reject) => {
					this.$api.purchasestockbill.list({
						...page,
						...updateForm,
						...other,
						...{directly:1}
					}).then((res) => {
						resolve(res)
					}, () => {
						reject()
					})
				})
			},
			sendjindie(){
				let data =  this.$refs.directlystockinList.getCheckboxRecords()
				if(!data.length){
					this.$message.error('请选择数据')
					return
				}				
				// data.forEach((item)=>{
				// 	this.loading = true
				// 	this.$api.reconciliation_bankflow.sendjindie({id:item.id}).then(()=>{
				// 		this.loading = false
				// 		this.customreload()
				// 	},()=>{
				// 		this.loading = false
				// 	})
				// })
			},
			submit() {
				//this.init()
			},
			reset() {
				//this.init()
			}
		},
		components: {
			
		}
	}
</script>